<div class="bg-surface-700 h-2 w-full overflow-hidden rounded-full" [attr.data-testid]="testId()">
  <div
    class="h-full rounded-full"
    [style.width.%]="percentage()"
    [style.backgroundColor]="fillColor()"
  ></div>
</div>
